import Image from 'next/image'

import Box from '@totallymoney/ui/components/Box'

import backgroundScoreLinesSemiCircleAqua10 from '@images/scorelines-semi-circle-aqua10.png'
import backgroundScoreLinesSemiCirclePurple40 from '@images/scorelines-semi-circle-purple40.png'

const UnscoredCategoryPageBackgroundTextureProsAndCons = () => (
    <>
        <Box
            display={['none', 'none', 'flex']}
            alignItems="center"
            position="absolute"
            left={0}
            height="90%"
            aria-hidden="true"
        >
            <Image
                src={backgroundScoreLinesSemiCircleAqua10}
                alt=""
                placeholder="empty"
                sizes="100vw"
                quality={60}
                priority={false}
            />
        </Box>

        <Box
            display={['none', 'none', 'flex']}
            alignItems="flex-end"
            position="absolute"
            right={0}
            height="90%"
        >
            <Image
                src={backgroundScoreLinesSemiCirclePurple40}
                alt="Scorelines circle background texture"
                placeholder="empty"
                sizes="100vw"
                quality={60}
                priority={false}
            />
        </Box>
    </>
)

export default UnscoredCategoryPageBackgroundTextureProsAndCons
